module.exports = __webpack_public_path__ + "media/images/why-ih-1-f892244955951fdb9061b5f84c7b87de.svg";